import type { AppType } from '@server/app'
import { env } from '@server/shared/constants/env'
import { EFFECTIVE_LOCALE_COOKIE_KEY, isSupportedLocale, type Locale } from '@shared/config/i18n/locales'
import { getBrowserAuthSession } from '@shared/libs/browser-auth-session'
import { hc } from 'hono/client'

const getCookieValue = (name: string) => {
  if (typeof document === 'undefined') {
    return undefined
  }

  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`))
  return match ? decodeURIComponent(match[2]) : undefined
}

const getRpcEffectiveLocale = (): Locale => {
  const effectiveLocale = getCookieValue(EFFECTIVE_LOCALE_COOKIE_KEY)
  return isSupportedLocale(effectiveLocale) ? effectiveLocale : 'en'
}

export const rpc = hc<AppType>(env.NEXT_PUBLIC_API_URL, {
  headers: {
    'cache-control': 'no-cache',
  },
  fetch: (input: RequestInfo | URL, init?: RequestInit) => {
    const request = new Request(input, init)

    if (!request.headers.has('Accept-Language')) {
      request.headers.set('Accept-Language', getRpcEffectiveLocale())
    }

    return getBrowserAuthSession()?.fetch(request) ?? fetch(request)
  },
})
